import * as React from 'react';
import { Button } from '../Button';
export const ButtonIcon = React.forwardRef(({ children, ...props }, forwardedRef) => (React.createElement(Button, { ref: forwardedRef, iconLeft: children, ...props })));
ButtonIcon.displayName = 'ButtonIcon';
//# sourceMappingURL=ButtonIcon.js.map